import {
  aLogMapping,
  aLogMappingPage,
  mockLogMappingsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockLogMappingsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          logMappings: aLogMappingPage({
            total: 2,
            hasNextPage: false,
            objects: [
              aLogMapping({
                id: '1',
                source: 'custom',
                isEnabled: true,
              }),
            ],
          }),
        },
      });
    }
  ),
];
